module.exports = __webpack_public_path__ + "img/501-bc16b5.png";